import { NewProject } from "@features/layout/newProject";

export const ProjectPage = () => {
  return <NewProject />;
};
